import { BookOpen, Heart, Home } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "../api/client";
import type { MediaSeries } from "../api/types";
import { CommandButton } from "../components/CommandButton";
import { PageShell } from "../components/PageShell";
import {
  DEFAULT_ERROR_RECOVERY_ACTION,
  StatusBlock,
} from "../components/StatusBlock";
import { useNavigationStore } from "../stores/navigationStore";
import styles from "../styles/App.module.css";

export function MediaPage() {
  const go = useNavigationStore((state) => state.go);
  const home = useNavigationStore((state) => state.home);
  const [series, setSeries] = useState<MediaSeries[]>([]);
  const [seriesLoaded, setSeriesLoaded] = useState(false);
  const [error, setError] = useState("");
  const audiobookSeries = series.filter(
    (item) => item.media_type === "audiobook" || item.category === "有声小说",
  );
  const operaSeries = series.filter((item) => !audiobookSeries.includes(item));

  useEffect(() => {
    api
      .mediaSeries()
      .then((result) => {
        setSeries(result.items);
        setSeriesLoaded(true);
      })
      .catch((loadError) => {
        setError(
          loadError instanceof Error ? loadError.message : "读取节目失败。",
        );
        setSeriesLoaded(true);
      });
  }, []);

  return (
    <PageShell title="听戏和评书" where="听戏和评书菜单">
      {error ? (
        <StatusBlock
          tone="error"
          message={error}
          recoveryAction={DEFAULT_ERROR_RECOVERY_ACTION}
        />
      ) : null}
      {!error && !seriesLoaded ? (
        <StatusBlock message="正在读取戏曲评书。" />
      ) : null}
      {!error && seriesLoaded && series.length === 0 ? (
        <StatusBlock message="暂时没有戏曲评书。请家人稍后添加节目。" />
      ) : null}
      <div className={styles.commandList}>
        <CommandButton
          icon={Heart}
          title="我收藏的戏曲评书"
          hint="收藏入口在本页第一项"
          onClick={() => go({ name: "favorites" })}
        />
        {operaSeries.length ? (
          <h2 className={styles.sectionHeading}>听戏</h2>
        ) : null}
        {operaSeries.map((item) => (
          <CommandButton
            key={item.id}
            icon={BookOpen}
            title={item.title}
            hint={`${item.category}，${item.total_episodes} 集，双击进入`}
            onClick={() => go({ name: "series", seriesId: item.id })}
          />
        ))}
        {audiobookSeries.length ? (
          <h2 className={styles.sectionHeading}>有声小说</h2>
        ) : null}
        {audiobookSeries.map((item) => (
          <CommandButton
            key={item.id}
            icon={BookOpen}
            title={item.title}
            hint={`${item.category}，${item.total_episodes} 集，双击进入`}
            onClick={() => go({ name: "series", seriesId: item.id })}
          />
        ))}
        <CommandButton
          icon={Home}
          title="列表末尾，返回主菜单"
          hint="这是本页最后一个节目操作，双击返回主菜单"
          onClick={home}
        />
      </div>
    </PageShell>
  );
}
